import { useState, FC, useEffect, SetStateAction, Dispatch, useCallback, useRef } from "react";
import classNames from "classnames";
import tabsStyles from "../../../../pages/styles//homePage.module.scss";
import Styles from "./Styles/ScanModalStyle.module.scss";
import { KizModalContent } from "./kiz/KizModalContent";
import { BoxModalContent } from "./box/BoxModalContent";
import { ITabsPanelAction, ITabsPanelState, useDetailsTabsPanel } from "../../../../system/hooks/useTabsPanel";
import { BarcodeType, IKizBoxDTO, IKizConfirmationData, IKizDTO, IKizStatusDTO, IKizStatusMoveErrorInDTO, IKizViewDTO, IParsedBarcode } from "../../../../libs/coreapi-dto/dirs/kiz";
import CommandsPanel from "../../../../hoc/CommandsPanel/CommandsPanel";
import { ClearButton, Delete2Button } from "../../../../components/buttons/iconButtons/action/MainCollection";
import { TabsPanel } from "../../../../components/tabs";
import { InvoiceItemGridPluginSettings } from "../../../Documents/Invoice/InvoiceItem";
import { ScanKizTabTitle } from "../KizView/KizViewTab";
import { ScanBoxTabTitle } from "./box/ScanBoxTab";
import { BaseModalWindow } from "../../../../components/modalWindows/BaseModalWindow";
import { v4 as uuidv4 } from "uuid";
import { TextInput } from "../../../../components/controls/inputs";
import { Button } from "../../../../components/buttons/button";
import { useTranslation } from "react-i18next";
import { KizDataProvider } from "../../../../Services/DataProviders/KizDataProvider";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import useGridFilter from "../../../../system/hooks/useGridFilter";
import { InvoiceDataProvider } from "../../../../Services/DataProviders/InvoiceDataProvider";
import { KizBoxDataProvider } from "../../../../Services/DataProviders/KizBoxDataProvider";
import { IBaseDocumentItemKizDTO } from "../../../../libs/coreapi-dto/documents/base";
import { DocumentType, EncodingType, KizStateType, SysOptionName } from "../../../../@types/enumsGlobal";
import { KizEntity } from "../KizEntity";
import { KizBoxEntity } from "../KizBoxEntity";
import GridWrapper from "../../../../components/controls/GridWrapper";
import buffer from "buffer";
import renderGlobalAlert from "../../../../system/hooks/useGlobalAlert";
import { BarcodeDataProvider } from "../../../../Services/DataProviders/BarcodeDataProvider";
import { IDocumentInfoDTO } from "../../../../libs/coreapi-dto/@types/common";
import { ScalingRatioDataProvider } from "../../../../Services/DataProviders/ScalingRatioDataProvider";
import { IScalingRatioDTO } from "../../../../libs/coreapi-dto/dirs/scalingRatio";
import { useComPortScanner } from "../../../../system/hooks/useHubConnection";
import { ScanKizCreatePluginSettings } from "./kiz/ScanKizCreatePluginSettings";
import { ScanKizActDisagregationPluginSettings } from "./kiz/ScanKizActDisagregationPluginSettings ";
import { cyrillicKeyboardTranslation } from "../../../../system/functions/keyboardLanguageTranslation";
import { KisOsuModalContent } from "./kizOsu/KizOsuModalContent";
import { IKizOsuEditDTO } from "../../../../libs/coreapi-dto/dirs/KizOsu";
import { ScanKizOsuTabTitle } from "./kizOsu/ScanKizOsuTab";
import { KizParsed } from "../KizParsed";
import { SysOptionsDataProvider } from "../../../../Services/DataProviders/SysOptionsDataProvider";
import { GoodsDataProvider } from "../../../../Services/DataProviders/GoodsDataProvider";
import { ProgressActionSpinner } from "../../../../components/progressActionSpinner/ProgressActionSpinner";
import { PaletteBoxTabTitle } from "./box/PaletteBoxTab";
import { PaletteModalContent } from "./box/PaletteModalContent";
import { ScanKizConfirmationModalContent } from "./kiz/ScanKizConfirmationModalContent";
import { ScanKizConfirmationViewPluginSettings } from "./kiz/ScanKizConfirmationViewPluginSettings";
import { ISysOptionsDTO, SysOptionsNamesDto } from "../../../../libs/coreapi-dto/service/sysOptions";
import { IKizAllowResponse } from "../../../../libs/coreapi-dto/dirs/barcode";
import { ScanBoxGismtTabTitle } from "./boxGismt/ScanBoxGismtTab";
import { BoxGismtModalContent } from "./boxGismt/BoxGismtModalContent";
import { IKizBoxGismtDTO } from "../../../../libs/coreapi-dto/dirs/kiz";
import { ProcessKizReturnType } from "./interface/IKizResult";
import { Accordion } from "../../../../components/controls/accordion";
import { playAlertSound } from "../../../../system/functions/beepSound";
import { checkCapsLock } from "../../../../system/functions/capsLockHelper";
import { promisifyLoadDataMethodWithTotalCount } from "../../../../system/functions/promisifyMethod";

interface IKizScanModalComponentProps extends ISelectorGridProps {
    detailsTabsPanel: ITabsPanelState;
    dispatchDetailsTabsPanel: (data: ITabsPanelAction) => void;
    kizData: IKizDTO[];
    boxData: IKizBoxDTO[];
    boxGismtData: IKizBoxGismtDTO[];
    paletteData: IKizBoxDTO[];
    kizConfirmationScanned: IKizConfirmationData[]
    kizOsu?: IKizOsuEditDTO;
    kizOsuDtos: IKizDTO[];
    setKizOsuDtos: (data: IKizDTO[]) => void;
    setKizData: (data: IKizDTO[]) => void;
    setBoxData: (data: IKizBoxDTO[], newBox?: IKizBoxDTO) => void;
    setBoxGismtData: (data: IKizBoxGismtDTO[], newBoxGismt?: IKizBoxGismtDTO) => void;
    setKizConfirmationScanned: (data: IKizConfirmationData[]) => void
    setKizOsuData: (data?: IKizOsuEditDTO) => void;
    selectedKizItem: IGridRow | undefined;
    setSelectedKizItem: (data: IGridRow | undefined) => void;
    setSelectedKizOsuDtosItem: (data: IGridRow | undefined) => void;
    selectedBoxItem: IGridRow | undefined;
    selectedBoxGismtItem: IGridRow | undefined;
    selectedKizOsuDtosItem: IGridRow | undefined;
    setSelectedBoxItem: (data: IGridRow | undefined) => void;
    setSelectedBoxGismtItem: (data: IGridRow | undefined) => void;
    scalingRatio: IScalingRatioDTO | undefined;
    setScalingRatio: (data: IScalingRatioDTO | undefined) => void;
    scanCount: number;
    scanCounts: ScanCounts;
    barcode: string;
    setBarcode: (value: string) => void;
    setScanCount: (data: number) => void;
    totalScanCount: number;
    totalScanBoxCount?: number;
    totalScanBoxGismtCount?: number;
    totalScanKizCount?: number;
    stringEncoding: EncodingType;
    isKiz: boolean;
    isKizBox?: boolean;
    showDevProp: boolean;
    canScanKiz?: boolean;
    canScanKizBox?: boolean;
    setCanScanKizBox: (value: boolean) => void;
    documentType: DocumentType;
    document: IDocumentInfoDTO;
    idLotFrom: string | null;
    inputFocus: boolean;
    isEditKizs?: boolean;
    isLs?: boolean; //Товар = лекарственное средство
    isSysOptionLs?: boolean //Константа = проверять на лекарственное средство или нет
    isPieceAccountingKizOsu: boolean //Константа определяет режим работы "поэкземплярный учет товаров ГИС МТ" #94150 
    onValidateDuplicate?: (barcode: string, kizs?: IKizDTO[], kizBoxes?: IKizBoxDTO[], _kizOsuDtos?: IKizDTO[], boxGismtData?: IKizBoxGismtDTO[]) => boolean | null;
    onCustomAllow?: (...params: any[]) => Promise<boolean>;
    idGoodsGlobal?: string;
    numerator: number;
    executeAfterScan: [boolean, Dispatch<SetStateAction<boolean>>];
    idDocumentItem: string;
    isPalette?: boolean;
    confirmationMode?: boolean;
    gisMtOnlyMode?: boolean;
    gtin?: string
}

interface ISelectingFromDictionaryKiz extends IGridSelectorModalProps {
    selectedItem: IBaseDocumentItemKizDTO;
    scalingRatio?: IScalingRatioDTO;
    setScalingRatio?: (scalingRatio: IScalingRatioDTO, idGlobal: string) => void
    numerator: number;
    idGoodsGlobal?: string;
    documentId?: string;
    canScanKiz?: boolean;
    canScanKizBox?: boolean;
    isFocusScanKizBox?: boolean;
    totalScanBoxCount?: number;
    totalScanBoxGismtCount?: number;
    totalScanKizCount?: number;
    isGetKizesBySscc?: boolean;
    documentType: DocumentType;
    sysOptionsKizValidationType?: string;
    document: IDocumentInfoDTO;
    idLotFrom: string | null;
    isEditKizs?: boolean;
    onValidateDuplicate?: (barcode: string, kizs?: IKizDTO[], kizBoxes?: IKizBoxDTO[], _kizOsuDtos?: IKizDTO[], boxGismtData?: IKizBoxGismtDTO[]) => boolean | null;
    onCustomAllow?: (...params: any[]) => Promise<boolean>;
    isPalette?: boolean;
    confirmationMode?: boolean;
    gisMtOnlyMode?: boolean;
}

interface ScanCounts {
    box: number;
    kiz: number;
    kizOsuDtos: number;
    boxGismt: number;
}

interface ICannotBeCreated {
    isAllow: boolean
    errorMessages: string
}

const KizScanModal: FC<ISelectingFromDictionaryKiz> = (props) => {
    const appCtx = useAppContext();

    const kizDataProvider = new KizDataProvider(appCtx.coreApiService);
    const kizBoxDataProvider = new KizBoxDataProvider(appCtx.coreApiService);
    const sysOptionsDataProvider = new SysOptionsDataProvider(appCtx.coreApiService)
    const invoiceDP = new InvoiceDataProvider(appCtx.coreApiService);
    const goodsDP = new GoodsDataProvider(appCtx.coreApiService);

    const [isSysOptionLs, setIsSysOptionLs] = useState<boolean>(false)
    const [isPieceAccountingKizOsu, setIsPieceAccountingKizOsu] = useState<boolean>(props.selectedItem?.isPieceAccountingKizOsu ?? props.gisMtOnlyMode ?? false)
    
    const canScanKiz: boolean = props.canScanKiz ?? true;
    const [canScanKizBox, setCanScanKizBox] = useState<boolean>(props.canScanKizBox ?? true);
    const isEditKizs: boolean = props.isEditKizs ?? false;

    const getTotalCount = (): number => {
        if (props.documentType === DocumentType.disassembling) {
            return selectedItemForPosition.quantityFrom ?? selectedItemForPosition.quantity;
        }

        if (props.documentType === DocumentType.invoice) {
            if (props.sysOptionsKizValidationType === 'ActualQuantity') {
                return selectedItemForPosition.actualQuantity as number;
            } else {
                return selectedItemForPosition.quantity;
            }
        }

        if ((props.documentType === DocumentType.importRemains) || 
            (props.documentType === DocumentType.movement) ||
            (props.documentType === DocumentType.inventoryVed)) {
            if ((props.scalingRatio?.numerator as number) < (props.scalingRatio?.denominator as number)) {
                return 1;
            } else {
                return selectedItemForPosition.quantity;
            }
        }

        return selectedItemForPosition.quantity;
    }

    // selected item for position
    const [selectedItemForPosition, setSelectedItemForPosition] = useState<IBaseDocumentItemKizDTO>(props.selectedItem);
    // Counter
    const [scanCounts, setScanCounts] = useState<ScanCounts>({
        box: 0,
        kiz: 0,
        kizOsuDtos: 0,
        boxGismt: 0
    });

    const [scanCount, setScanCount] = useState<number>(0);
    const [totalScanCount, setTotalScanCount] = useState<number>(getTotalCount());
    // details table
    const [detailsTabsPanel, dispatchDetailsTabsPanel] = useDetailsTabsPanel(InvoiceItemGridPluginSettings.mnemocode);
    //selected item in modal window
    const [selectedKizItem, setSelectedKizItem] = useState<IGridRow>();
    const [selectedBoxItem, setSelectedBoxItem] = useState<IGridRow>();
    const [selectedBoxGismtItem, setSelectedBoxGismtItem] = useState<IGridRow>();
    const [selectedKizOsuDtosItem, setSelectedKizOsuDtosItem] = useState<IGridRow>();

    const [isKiz, setIsKiz] = useState<boolean>(true);

    //data in modal window
    const [kizData, setKizData] = useState<IKizDTO[]>(props.selectedItem?.kizs ?? []);
    const [boxData, setBoxData] = useState<IKizBoxDTO[]>(props.isPalette ?
        props.selectedItem?.kizBoxes?.filter(x => x.idParent !== null) ?? [] :
        props.selectedItem?.kizBoxes ?? []);
    const [boxGismtData, setBoxGismtData] = useState<IKizBoxGismtDTO[]>(props.isPalette ?
        props.selectedItem?.kizBoxesGisMt?.filter(x => x.idParent !== null) ?? [] :
        props.selectedItem?.kizBoxesGisMt ?? []);
    const [paletteData, setPaletteData] = useState<IKizBoxDTO[]>(props.selectedItem?.palettes ?? []);
    const [kizOsu, setKizOsu] = useState<IKizOsuEditDTO | undefined>(props.selectedItem.kizOsuDto ?? undefined);
    const [kizOsuDtos, setKizOsuDtos] = useState<IKizDTO[]>(props.selectedItem.kizOsuDtos ?? []);
    const [kizConfirmationScanned, setKizConfirmationScanned] = useState<IKizConfirmationData[]>(props.selectedItem?.kizConfirmationScanned ?? []);

    const [scalingRatio, setScalingRatio] = useState<IScalingRatioDTO | undefined>(props.scalingRatio)
    const [showDevProp, setShowDevProp] = useState<boolean>(true);
    const [goodsName, setGoodsName] = useState<string>('');
    const [loader, setLoader] = useState<boolean>(true);

    const [gridFilter, dispatchGridFilter] = useGridFilter();

    const [inputFocus, setInputFocus] = useState<boolean>(true);

    // //Чтобы при открытии не было сигнала, когда кизы заполнены
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (scanCount === totalScanCount) {
            setInputFocus(false);
            
            // Воспроизводим звук только если это не первый рендер
            if (!isFirstRender.current) {
                playAlertSound("success");
            }
            
            // Сбрасываем флаг после первого совпадения
            isFirstRender.current = false;
        } 
        // Сбрасываем флаг при любом изменении scanCount > 0
        else if (scanCount > 0) {
            isFirstRender.current = false;
        }
    }, [scanCount, totalScanCount]);

    const [barcode, setBarcode] = useState<string>("");
    const [stringEncoding, setStringEncoding] = useState<EncodingType>(EncodingType.ascii);
    const [executeAfterScan, setExecuteAfterScan] = useState<boolean>(false);

    function responseScanAndParseValidator(responseWS) {
        kizDataProvider.parse(responseWS, (parsedBarcode) => {
            if (parsedBarcode.barcodeType === 'Kiz') {
                setBarcode(parsedBarcode.kizData.decodedBarcode);
                setStringEncoding(EncodingType.ascii);
                setExecuteAfterScan(true)
            }
            else if (parsedBarcode.barcodeType === 'KizOsu') {
                setBarcode(parsedBarcode.kizOsuData.decodedBarcode);
                setStringEncoding(EncodingType.ascii);
                setExecuteAfterScan(true)
            }
            else if (parsedBarcode.barcodeType === 'KizBox') {
                setBarcode(parsedBarcode.kizBoxData.sscc);
                setStringEncoding(EncodingType.ascii);
                setExecuteAfterScan(true)
            }
        });
    }

    const scanner = useComPortScanner((responseWS) => {
        if (responseWS && scanCount < totalScanCount) {
            
            const decodedText = atob(responseWS);
            let kizParsed = new KizParsed(decodedText)

            const scanDataBase64: string = stringEncoding === EncodingType.ascii 
                ? buffer.Buffer.from(kizParsed.rawBarcodeCorrected, "ascii").toString("base64") 
                : kizParsed.rawBarcodeCorrected;
            const encodedBarcode = encodeURIComponent(scanDataBase64);

            responseScanAndParseValidator(encodedBarcode);
        }
    })

   useEffect(() => {
        const dto: SysOptionsNamesDto = {
            sysOptionsNames: [
                SysOptionName.InvoiceIsLs, 
                SysOptionName.IndividualInventoryOfGoodsGISMT
            ]
        };

        const handleOptionsResponse = (options: ISysOptionsDTO[]) => {
            const invoiceIsLs = options.find(opt => opt.name === SysOptionName.InvoiceIsLs);
            const individualInventory = options.find(
                opt => opt.name === SysOptionName.IndividualInventoryOfGoodsGISMT
            );

            setIsSysOptionLs(invoiceIsLs?.value.toLowerCase() === 'true');
            if (props.documentType === DocumentType.invoice || props.documentType === DocumentType.importRemains ) {
                setIsPieceAccountingKizOsu(individualInventory?.value.toLowerCase() === 'true');
            }
            
        };

        const handleOptionsError = () => {
            console.error('Не удалось загрузить системные настройки');
        };

        sysOptionsDataProvider.getByNames(dto, (data) => {
            if (data && data.length > 0) {
                handleOptionsResponse(data);
            } else {
                handleOptionsError();
            }
        });

    }, []); 

    useEffect(() => {
        if (props.documentType === DocumentType.disaggregation ||
            props.documentType === DocumentType.invoice && props.isFocusScanKizBox) {
            dispatchDetailsTabsPanel({ type: "activate", payload: detailsTabsPanel.tabs.find(c => c.title === ScanBoxTabTitle) as ITab })
        }

        if (props.gisMtOnlyMode) {
            dispatchDetailsTabsPanel({ type: "activate", payload: detailsTabsPanel.tabs.find(c => c.title === ScanKizOsuTabTitle) as ITab })
        }

        if (props.isPalette) {
            //dispatchDetailsTabsPanel({type: "activate", payload: detailsTabsPanel.tabs.find(c => c.title === PaletteTabTitle) as ITab})
        }
        return () => {
            // deleteScanner
            scanner.disconnect();
        }
    }, []);

    useEffect(() => {

        // Выгрузка документа для киз/короба с пагинацией
        const loadKizData = async (idDocument: string) => {
            const allKizData: IKizViewDTO[] = [];
            const allBoxData: IKizBoxDTO[] = [];
            let currentPage = 1;
            let totalKizCount: number | null = null;
            let totalBoxCount: number | null = null;

            const pageSize = gridFilter?.numberPerPage || 15;

            // Загрузка всех КИЗов постранично
            while (totalKizCount === null || allKizData.length < totalKizCount) {
                const pageFilter = {
                    ...gridFilter,
                    pageNumber: currentPage,
                    numberPerPage: pageSize
                };

                const { data: entities, totalCount } = await promisifyLoadDataMethodWithTotalCount<IKizViewDTO[], typeof kizDataProvider>(
                    kizDataProvider,
                    kizDataProvider.getKizByItem,
                    idDocument,
                    props.selectedItem?.idGlobal,
                    pageFilter
                );

                if (totalKizCount === null) {
                    totalKizCount = totalCount;
                }

                allKizData.push(...entities);
                currentPage++;
            }

            // Сброс страницы для коробов
            currentPage = 1;

            // Загрузка всех коробов постранично
            while (totalBoxCount === null || allBoxData.length < totalBoxCount) {
                const pageFilter = {
                    ...gridFilter,
                    pageNumber: currentPage,
                    numberPerPage: pageSize
                };

                const { data: entities, totalCount } = await promisifyLoadDataMethodWithTotalCount<any[], typeof kizBoxDataProvider>(
                    kizBoxDataProvider,
                    kizBoxDataProvider.getKizBoxByItem,
                    idDocument,
                    props.selectedItem?.idGlobal,
                    pageFilter
                );

                if (totalBoxCount === null) {
                    totalBoxCount = totalCount;
                }
                
                allBoxData.push(...entities);
                currentPage++;
            }

            // Установка финальных данных в состояние
            setKizData((prevKizData) => [
                ...prevKizData,
                ...allKizData.map((x: IKizViewDTO) => ({
                    idGlobal: x.idGlobal,
                    barcode: x.barcode,
                    decodedBarcode: x.decodedBarcode,
                    rawBarcode: x.rawBarcode,
                    gtinSGtin: x.gtinSGtin,
                    sGtin: x.sGtin,
                    gtin: x.gtin,
                    moveState: x.moveState,
                    kizState: x.kizState,
                    idError: x.idError,
                    isTrusted: x.isTrusted,
                    isHandScan: x.isHandScan,
                    barcodeScan: x.barcodeScan,
                    lotName: x.lotName,
                    code: x.code,
                    docType: x.docType,
                    error: x.error,
                    documentOutId: x.documentOutId,
                    remain: x.remain,
                    idParent: x.idParent,
                    goodsGroup: x.goodsGroup,
                    goodsGroupCode: x.goodsGroupCode,
                    state: x.state,
                    numerator: x.numerator,
                    denominator: x.denominator,
                    idDocumentItemAdd: x.idDocumentItemAdd
                }))
            ]);
            setBoxData(allBoxData);
        };

        // Функция для загрузки всех строк документа
        const loadAllDocumentItems = async (documentId: string): Promise<any[]> => {
            const allItems: any[] = [];
            let currentPage = 1;
            let totalCount: number | null = null;
            const pageSize = gridFilter?.numberPerPage || 15;

            while (totalCount === null || allItems.length < totalCount) {
                const pageFilter = {
                    ...gridFilter,
                    pageNumber: currentPage,
                    numberPerPage: pageSize
                };

                const { data: entities, totalCount: total } = await promisifyLoadDataMethodWithTotalCount<any[], typeof invoiceDP>(
                    invoiceDP,
                    invoiceDP.getItemsView,
                    documentId,
                    pageFilter
                );

                if (totalCount === null) {
                    totalCount = total;
                }

                allItems.push(...entities);
                currentPage++;
            }

            return allItems;
        };

        // Универсальный документ, связанный с ведомостью
        if (props.documentId) {
            loadAllDocumentItems(props.documentId as string)
                .then((allItems) => {
                    if (allItems.find((x) => x.idGlobal === (props.selectedItem?.idGlobal as string))) {
                        loadKizData(props.documentId as string);
                    }
                })
                .catch((error) => {
                    console.error('Ошибка загрузки строк документа:', error);
                });
        }

        // Конкретные документы

        // Инвентаризация
        if (props.documentType === DocumentType.inventoryVed) {
            loadKizData(props.document?.idDocument);
        }
    }, []);

    useEffect(() => {
        setIsKiz(detailsTabsPanel.currentTab?.title === ScanKizTabTitle);
    }, [detailsTabsPanel.currentTab]);

    useEffect(() => {
        if (props.documentType === DocumentType.disaggregation) {
            if (kizData.length <= 0) setScanCounts(prev => ({...prev,kiz: 0,}));
            else {
                let count = Math.floor(kizData.length / (scalingRatio?.numerator ?? props.numerator));
                setScanCounts(prev => ({...prev,kiz: count,}));
            }
        }
        else setScanCounts(prev => ({...prev,kiz: kizData.length, kizOsuDtos: kizOsuDtos.length, boxGismt: boxGismtData.length}));

        const countBox = boxData.reduce((prev, current) => prev + current.quantity, 0) / (scalingRatio?.numerator ?? props.numerator);
        setScanCounts(prev => ({...prev,box: countBox,}));
    }, [kizData, kizOsuDtos, boxData, boxGismtData, paletteData, scalingRatio]);

    useEffect(() => {
        setScanCount(scanCounts.kiz + scanCounts.box + scanCounts.kizOsuDtos + scanCounts.boxGismt);
    }, [scanCounts]);

    useEffect(() => {
        if (kizOsu) {
            setScanCount(1);
            setTotalScanCount(1);
        } else {
            setScanCount(scanCounts.kiz + scanCounts.box + scanCounts.boxGismt);
            setTotalScanCount(getTotalCount());
        }
    }, [kizOsu]);

    useEffect(() => {
        if (selectedItemForPosition) {
            setSelectedItemForPosition({
                ...selectedItemForPosition,
                kizs: kizData,
                kizBoxes: boxData,
                kizBoxesGisMt: boxGismtData,
                kizOsuDtos: kizOsuDtos,
                kizOsuDto: kizOsu,
                isOsu: kizOsu !== undefined,
                isKiz: true,
                isKizBox: boxData.length > 0
            })
        }
    }, [kizData, kizOsuDtos, boxData, kizOsu, boxGismtData]);

    const getKizesBySscc = (sscc: string) => {
        kizDataProvider.getKizBySscc(sscc, (e: any) => {
            setKizData([
                ...e.map((x: any) => {
                    return {
                        idGlobal: x.idGlobal,
                        barcode: x.barcode,
                        sGtin: x.sGtin,
                        gtin: x.gtin,
                        serialNumber: x.serialNumber,
                        bestBefore: x.bestBefore,
                        batchNumber: x.batchNumber,
                        idError: x.idError,
                    };
                }),
            ]);
        });
    };

    const validateCountDisagregation = (): boolean => {

        const showWarning = (message: string) => {
            renderGlobalAlert({
                variant: "warning",
                title: message,
                statusCode: 500,
                isSound: true
            });
            return false;
        };

        if (props.isPalette) {
            if (boxData.length > scanCounts.box) {
                return showWarning("Превышено количество коробов");
            }
        } else {
            if (boxData.length > 1) {
                return showWarning("Превышено количество коробов, больше одного");
            }

            if (props.confirmationMode) {
                const numerator = scalingRatio?.numerator ?? props.numerator;
                const scannedCount = kizConfirmationScanned.filter(
                    x => x.infoScanned?.length > 0
                ).length;

                const countConfirm = Math.floor(scannedCount / numerator);

                if (countConfirm > scanCounts.box) {
                    return showWarning(`Превышено количество подтвержденных кизов, подтверждено больше чем ${scanCounts.box}`);
                }
            }
        }

        return true;
    };

    const validateCount = (): boolean => {
        if (props.documentType === DocumentType.disaggregation)
            return validateCountDisagregation()

        if (props.selectedItem.quantity < scanCount) {
            renderGlobalAlert({
                variant: "warning",
                title: `Максимально допустимое кол-во кизов ${props.selectedItem.quantity}, отсканировано ${scanCount}`,
                statusCode: 500,
                isSound: true
            });
            return false;
        }

        return true;
    };

    const validateConfirmation = () => {
        if (!props.confirmationMode) return true;

        let countConfirm: number = kizConfirmationScanned.filter(x => x.infoScanned && x.infoScanned.length > 0).length;
        if (countConfirm !== kizData.length) {
            renderGlobalAlert({
                variant: "warning",
                title: `Не все КИЗ подтверждены, отсканировано ${countConfirm}`,
                statusCode: 0,
                isSound: true
            });
        }
    }

    useEffect(() => {
        // Вывод наименования товара
        if (props.selectedItem && props.selectedItem.idGoodsGlobal) {
            goodsDP.getById(props.selectedItem?.idGoodsGlobal, (data) => {
                setGoodsName(data.goodsName?.name)
                setLoader(false);
            })
        } else {
            setLoader(false);
        }
    }, [])

    if (loader) return <ProgressActionSpinner className={Styles.actionSpinner} />

    return (
        <BaseModalWindow
            //autoFocus={inputFocus ? false : true}
            header={`Контрольные (идентификационные) знаки: ${goodsName}`}
            ok={{
                onClick: () => {
                    if (!validateCount()) return;
                    validateConfirmation();

                    if (props.documentType === DocumentType.invoice && (scalingRatio?.numerator ?? props.numerator) <= 1 && scanCount > totalScanCount) {
                        props.ok?.({ ...selectedItemForPosition, quantity: scanCount }, scalingRatio);
                    } else {
                        let documentItem = props.isPalette ? { ...selectedItemForPosition, palettes: paletteData } : selectedItemForPosition;
                        if (props.confirmationMode)
                            documentItem = { ...documentItem, kizConfirmationScanned: kizConfirmationScanned }

                        props.ok?.(documentItem, scalingRatio);
                    }
                },
                title: "Сохранить и закрыть",
            }}
            cancel={{
                onClick: () => {
                    props.cancel?.();
                },
                title: "Закрыть без  сохранения",
            }}
            modalWindowClassName={Styles.modalWindow}
            footerStyle="customStyles"
        >
            <div>
                <KizScanModalContent
                    executeAfterScan={[executeAfterScan, setExecuteAfterScan]}
                    barcode={barcode}
                    idDocumentItem={selectedItemForPosition.idGlobal}
                    setBarcode={(value: string) => setBarcode(value)}
                    showDevProp={showDevProp}
                    detailsTabsPanel={detailsTabsPanel}
                    dispatchDetailsTabsPanel={(data) => dispatchDetailsTabsPanel(data)}
                    kizData={kizData}
                    setKizData={(data) => setKizData(data)}
                    setBoxGismtData={(data) => setBoxGismtData(data)}
                    setKizConfirmationScanned={(data) => setKizConfirmationScanned(data)}
                    setKizOsuData={(data) => setKizOsu(data)}
                    boxData={boxData}
                    boxGismtData={boxGismtData}
                    paletteData={paletteData}
                    kizConfirmationScanned={kizConfirmationScanned}
                    kizOsu={kizOsu}
                    kizOsuDtos={kizOsuDtos}
                    setKizOsuDtos={setKizOsuDtos}
                    setBoxData={(data, newBox) => {
                        setBoxData(data);
                        props.isGetKizesBySscc && newBox && getKizesBySscc(newBox.sscc);
                    }}
                    selectedKizItem={selectedKizItem}
                    selectedBoxGismtItem={selectedBoxGismtItem}
                    setSelectedKizItem={(data) => setSelectedKizItem(data)}
                    selectedKizOsuDtosItem={selectedKizOsuDtosItem}
                    setSelectedKizOsuDtosItem={(data) => setSelectedKizOsuDtosItem(data)}
                    selectedBoxItem={selectedBoxItem}
                    setSelectedBoxItem={(data) => setSelectedBoxItem(data)}
                    setSelectedBoxGismtItem={(data) => setSelectedBoxGismtItem(data)}
                    scanCount={scanCount}
                    scanCounts={scanCounts}
                    totalScanCount={totalScanCount}
                    setScanCount={(data) => setScanCount(data)}
                    stringEncoding={stringEncoding}
                    isKiz={isKiz}
                    isKizBox={props.selectedItem.isKizBox}
                    isLs={props.selectedItem.isLs}
                    isSysOptionLs={isSysOptionLs}
                    isPieceAccountingKizOsu={isPieceAccountingKizOsu}
                    canScanKiz={canScanKiz}
                    canScanKizBox={canScanKizBox}
                    setCanScanKizBox={(value) => setCanScanKizBox(value)}
                    totalScanBoxCount={props.totalScanBoxCount}
                    totalScanBoxGismtCount={props.totalScanBoxGismtCount}
                    totalScanKizCount={props.totalScanKizCount}
                    documentType={props?.documentType}
                    document={props.document}
                    idLotFrom={props.idLotFrom}
                    inputFocus={inputFocus}
                    isEditKizs={isEditKizs}
                    onValidateDuplicate={props.onValidateDuplicate}
                    onCustomAllow={props.onCustomAllow}
                    idGoodsGlobal={props.idGoodsGlobal}
                    setScalingRatio={(data) => setScalingRatio(data)}
                    scalingRatio={scalingRatio}
                    numerator={props.numerator}
                    isPalette={props.isPalette}
                    confirmationMode={props.confirmationMode}
                    gisMtOnlyMode={props.gisMtOnlyMode}
                    gtin={props.selectedItem?.gtin}
                />
            </div>
        </BaseModalWindow>
    );
};

const KizScanModalContent: FC<IKizScanModalComponentProps> = (props) => {
    const appCtx = useAppContext();

    const kizDataProvider = new KizDataProvider(appCtx.coreApiService);
    const barcodeDataProvider = new BarcodeDataProvider(appCtx.coreApiService);
    const scalingRatioProvider = new ScalingRatioDataProvider(appCtx.coreApiService);

    const [kizAllow, setKizAllow] = useState<boolean>(false);
    const [kizBoxAllow, setKizBoxAllow] = useState<boolean>(false);

    const [processingStats, setProcessingStats] = useState({
            isProcessing: false,
            current: 0,
            total: 0,
            errors: 0
        });   

    const [showGrid, setShowGrid] = useState(true);

    const isEditKizs: boolean = props.isEditKizs ?? false;
    const [isCanDeleteSelected, setIsCanDeleteSelected] = useState<boolean>(false);
    const [isCanDeleteAll, setIsCanDeleteAll] = useState<boolean>(false);
    const [isSelectScan, setIsSelectScan] = useState<boolean>(false)
    const [disabledTabIds, setDisabledTabsIds] = useState<string[]>([])
    
    const { t } = useTranslation();
    const errorsT = (value: string) => t("errors." + value);
    const [cannotBeCreated, setCannotBeCreated] = useState<ICannotBeCreated>({isAllow: true, errorMessages: ''});

    const barcode = useBarcode(props.barcode);

    const handleSetAllBoxData = (updatedBoxes: IKizBoxDTO[]) => {
        props.setBoxData(updatedBoxes);
    };
    const handleSetAllBoxGismtData = (updatedBoxes: IKizBoxGismtDTO[]) => {
        props.setBoxGismtData(updatedBoxes);
    };
    const isBoxGisMtTab = props.detailsTabsPanel.currentTab?.title === 'Короб ГИС МТ'
    const typeForBoxGisMt = isBoxGisMtTab ? 'KizBoxGisMt' : ''

    const [error, setError] = useState<string>()

    useEffect(() => {
        if (!error) return
        playAlertSound("danger")
    },[error])

    const isValid = (barcode: string): boolean => {

        if (!barcode) return false

        let tabCurrent = props.detailsTabsPanel.currentTab;
        let result = false
        setError('');
        //валидация короба ГИС МТ
        if (isBoxGisMtTab) {
            const isValidLength = barcode.length >= 18 && barcode.length <= 74;
            const isValidChars = /^[A-Za-z0-9%&'"()*+,\-_\.\/:;<=>?!]+$/.test(barcode);
            
            if (!isValidLength || !isValidChars) {
                setIsSelectScan(true);
                return false;
            }
            return true;
        } else {
            //formatData
            let kizParsed = new KizParsed(barcode)
            if (!KizBoxEntity.isKizBox(barcode) && !kizParsed.isKiz) {
                setIsSelectScan(true)
                setError(errorsT("wrongFormatKizOrKizBox"))
                return false;
            }

            //dataTypeKiz
            //валидация по формату ввода в поле на вкладке КИЗ при дезактивированной вкладке Короб
            
            if (tabCurrent && tabCurrent.title === ScanKizTabTitle && !props.canScanKiz) {
                if (KizBoxEntity.isKizBox(barcode)) {
                    setIsSelectScan(true)
                    setError(errorsT("inputKiz"))
                    return false;
                }
            }
            

            //валидация по формату ввода в поле на вкладке Короб при дезактивированной вкладке КИЗ
            //dataTypeKizBox: {        
            if (tabCurrent && tabCurrent.title === ScanBoxTabTitle && !props.canScanKizBox) {
                if (!KizBoxEntity.isKizBox(barcode)) {
                    setIsSelectScan(true)
                    setError(errorsT("inputKizBox"))
                    return false;
                }
            }
        }

        //kizExists
        result = setIsKizExist(barcode)
        if (!result) {
            setError(errorsT("kizExists"))
            setIsSelectScan(true)
            return false
        } 
        

        //валидация по количеству
        //quantity
        
        result = validScanCount(barcode)
        if (!result) {
            setError(errorsT("boxQuantity"))
            setIsSelectScan(true)
            return false
        }

        //cannotBeCreated
        if (!cannotBeCreated.isAllow) {
            setError('`КИЗ/Короб не возможно добавить.' + errorsT(cannotBeCreated.errorMessages))
            return false
        }

        //duplicate
        result = valdateDuplicate(barcode)
        if (!result) {
            setIsSelectScan(true)
            setError(errorsT("duplicate"))
            return false
        }
        //notCoincidenceGtin

        if (props.gtin && !(barcode.length === 18 || barcode.length === 20) && props.kizData.length == 0) {
            const gtin = props.gtin;

            if (gtin == undefined || gtin?.length == 0) {
                return true
            }

            const isInvalidGtin = barcode.length > 27 
                ? barcode.substring(2, 16) !== gtin
                : barcode.substring(0, 14) !== gtin;

            if (isInvalidGtin) {
                setIsSelectScan(true);
                setError(errorsT("notCoincidenceGtinLot") + ' ' + gtin)
                return false;
            }

        }

        if (!(barcode.length === 18 || barcode.length === 20) && props.kizData.length !== 0) {
             const gtin = props.gtin || props.kizData[0]?.gtin;
            // Если GTIN не найден ни в одном источнике - пропускаем проверку
            if (!gtin) {
                return true;
            }
            
            const isInvalidGtin = barcode.length > 27 
                ? barcode.substring(2, 16) !== gtin
                : barcode.substring(0, 14) !== gtin;
            
            if (isInvalidGtin) {
                setIsSelectScan(true);
                setError(errorsT("notCoincidenceGtin"))
                return false;
            }
        }

        //notSsccDivided
        result = !(props.documentType === DocumentType.importRemains &&
            ((props.scalingRatio?.numerator as number) < (props.scalingRatio?.denominator as number)) &&
            (barcode.length === 18 || barcode.length === 20))

        if (!result) {
            setIsSelectScan(true)
            setError(errorsT("notSsccDivided"))
            return false
        }

        //notKizInKizBox
        result = !(props.documentType === DocumentType.importRemains &&
            ((props.scalingRatio?.numerator as number) > (props.scalingRatio?.denominator as number)) &&
            !(barcode.length === 18 || barcode.length === 20))
        if (!result) {
            setIsSelectScan(true)
            setError(errorsT("notKizInKizBox"))
            return false
        }

        return true;
    }

    const validScanCount = (barcode: string): boolean => {
        if (!barcode) return true

        let tabCurrent = props.detailsTabsPanel.currentTab;
        let totalScanCount = props.totalScanCount;

        if (props.totalScanBoxCount && tabCurrent) {
            if (tabCurrent.title === ScanBoxTabTitle && barcode.length === 20) {

                const packedLength = props.boxData.length;
                if (props.documentType === DocumentType.disaggregation) {
                    if (packedLength >= props.totalScanBoxCount) return false
                    if (props.isPalette) return true
                }

                return props.scanCounts.kiz < props.totalScanBoxCount;
            } else if (props.totalScanKizCount && tabCurrent.title === ScanKizTabTitle && props.boxData.length > 0 && barcode.length !== 20) {
                if (props.documentType === DocumentType.disaggregation) {
                    let countConfirm = props.kizData.filter(c => c.isTrusted).length
                    if (props.scanCounts.box === 0) return false
                    return countConfirm < props.totalScanKizCount;
                }
                else return props.scanCounts.kiz < props.totalScanKizCount;
            }
            else if (props.boxData.length === 0) return false
        }
        if (props.totalScanBoxGismtCount && tabCurrent) {
            if (tabCurrent.title === ScanBoxGismtTabTitle && barcode.length === 20) {
                const packedLength = props.boxGismtData.length;
                if (props.documentType === DocumentType.disaggregation) {
                    if (packedLength >= props.totalScanBoxGismtCount) return false
                    if (props.isPalette) return true
                }
                return props.scanCounts.kiz < props.totalScanBoxGismtCount;
            } 
        }
        return props.scanCount < totalScanCount;
    }

    const valdateDuplicate = (barcode: string): boolean => {
        if (!barcode) return true

        if (!props.onValidateDuplicate) return true;
        const scanDataBase64: string = props.stringEncoding === EncodingType.ascii ? buffer.Buffer.from(barcode, "ascii").toString("base64") : barcode;

        if (!props.onValidateDuplicate(scanDataBase64, props.kizData, props.boxData, props.kizOsuDtos, props.boxGismtData)) {
            renderGlobalAlert({
                variant: "exception",
                title: `${barcode} уже был добавлен ранее в текущем документе`,
                statusCode: 500,
                isSound: true
            });
            return false;
        }
        return true;
    };

    const setIsKizExist = (_barcode: string): boolean => {
        if (!_barcode) return true

        let kizParsed = new KizParsed(_barcode)
        if (props.documentType === DocumentType.disaggregation) {
            const scanDataBase64: string = props.stringEncoding === EncodingType.ascii ? buffer.Buffer.from(_barcode, "ascii").toString("base64") : _barcode;
            let isTrusted = props.kizData.find((i) => i.barcode === scanDataBase64)?.isTrusted;
            if (!isTrusted) {
                return true;
            }
            return false;
        }

        if (props.kizData.filter((i) => i.gtinSGtin === kizParsed.gtinSgtin).length > 0 ||
            props.boxData.filter((i) => i.barcode === barcode.base64).length > 0 ||
            props.kizOsuDtos.filter((i) => i.gtinSGtin === kizParsed.gtinSgtin).length > 0) {
            return false;
        }

        for (let i = 0; i < props.boxData.length; i++) {
            if (_barcode === ('00' + props.boxData[i].sscc)) {
                return false
            } else {
                return true
            }
        }

        for (let i = 0; i < props.kizData.length; i++) {
            if (_barcode.length > 27 && props.kizData.length !== 0 && cyrillicKeyboardTranslation(_barcode.substring(18, 31)) === props.kizData[i]?.sGtin) {
                return false
            } else if (_barcode.length <= 27 && props.kizData.length !== 0 && cyrillicKeyboardTranslation(_barcode.substring(14, 27)) === props.kizData[i]?.sGtin) {
                return false
            } else {
                return true
            }
        }

        return true;
    };

    const hasParentKiz = (status: IKizStatusDTO): boolean => {
        let result = props.boxData.find((x) => x.idGlobal === status.kizData.idParent);
        if (!result) return false;
        return true;
    };

    const setKizData = (kiz: IKizDTO, newParsedBarcode?: IParsedBarcode): ProcessKizReturnType | null => {
        if (newParsedBarcode) {
            const decodedBarcode = newParsedBarcode.kizData.decodedBarcode
            // Проверка длины
            if (decodedBarcode.length > 150) {
                setError(errorsT("kizLength"))
                return null;
            }

            // Проверка запрещенных символов
            const forbiddenChars = ['#'];
            const result = forbiddenChars.some(char => decodedBarcode.includes(char));
            if (result)
            {
                setError(errorsT("kizForbiddenChars"))
                return null
            }
        }
        return {
            type: 'kiz',
            kiz
        }
    }

    const setDataKizVerify = (parseBarcode: IParsedBarcode, status: IKizStatusDTO, barcodeScan: string): ProcessKizReturnType => {
        if (props.documentType === DocumentType.disaggregation) {
            let hasParent = hasParentKiz(status);
            const newKiz = {
                ...parseBarcode.kizData,
                idGlobal: status.kizData.idKizGlobal,
                isTrusted: true,
                isHandScan: !hasParent,
                barcodeScan: barcodeScan,
            };
            
            // Возвращаем только новый киз
            return {
                type: 'kiz',
                kiz: newKiz,
            };
        } else {
            const newKiz = { 
                ...parseBarcode.kizData, 
                idGlobal: uuidv4() 
            };
            
            return {
                type: 'kiz',
                kiz: newKiz,
            };
        }
    };

   const getKizDto = (parsedBarcode: IParsedBarcode): IKizDTO => { 
        if (props.documentType === DocumentType.disaggregation) {
            return {
                ...parsedBarcode.kizData,
                idGlobal: uuidv4(),
                isTrusted: true,
                isHandScan: true
            };
        } else {
            return {
                ...parsedBarcode.kizData,
                idGlobal: uuidv4()
            };
        }
    }

    const definitionKizScan = (barcodeType: BarcodeType, tab?: string) => {
        if (!(barcodeType === BarcodeType.Kiz && props.canScanKiz)) return false

        if (!props.isSysOptionLs) {
            return tab === undefined ? true : props.detailsTabsPanel.currentTab?.title === tab
        }

        if (props.isSysOptionLs) {
            return tab === ScanKizTabTitle ? props.isLs : !props.isLs
        }
    }

    useEffect(() => {
        const { kizOsu, kizOsuDtos, kizData, boxData, detailsTabsPanel, boxGismtData } = props;
        
        const tabMapping = [
            { condition: kizOsu != undefined || kizOsuDtos?.length > 0, title: ScanKizOsuTabTitle },
            { condition: kizData?.length > 0, title: ScanKizTabTitle },
            { condition: boxData?.length > 0, title: ScanBoxTabTitle },
            { condition: boxGismtData?.length > 0, title: ScanBoxGismtTabTitle },
            ];

        const activeTab = tabMapping.find(item => item.condition);
        if (activeTab) {
            detailsTabsPanel.currentTab = detailsTabsPanel.tabs.find(c => c.title === activeTab.title);
        }
    }, [props.kizOsu, props.kizOsuDtos, props.kizData, props.boxData, props.boxGismtData]);

    const processKiz = async (barcode: string): Promise<ProcessKizReturnType> => {
        if (barcode && isValid(barcode)) {
            let kizParsed = new KizParsed(barcode)
            const scanDataBase64: string = props.stringEncoding === EncodingType.ascii 
                ? buffer.Buffer.from(kizParsed.rawBarcodeCorrected, "ascii").toString("base64") 
                : kizParsed.rawBarcodeCorrected;
            const encodedBarcode = encodeURIComponent(scanDataBase64); 
            
            // Оборачиваем allow в Promise для возможности await
            return new Promise((resolve, reject) => {
                barcodeDataProvider.allow(
                    {
                        barcode: encodedBarcode,
                        document: props.document,
                        idLot: props.idLotFrom,
                        type: typeForBoxGisMt
                    },
                    async (response: IKizAllowResponse) => {
                        
                        // Вспомогательные функции
                        const addKiz = async (kizStatus: IKizStatusDTO | null = null): Promise<any> => {
                            return new Promise((innerResolve, innerReject) => {
                                kizDataProvider.parse(encodedBarcode, (parsedBarcode) => {
                                    // Для РН, ПТ, Вед пробрасываем raw_barcode
                                    if (kizStatus?.kizData &&
                                        (
                                            props.documentType === DocumentType.invoiceOut ||
                                            props.documentType === DocumentType.movement ||
                                            props.documentType === DocumentType.inventoryVed
                                        )) {
                                        kizDataProvider.saveRawBarcode(
                                            kizStatus.kizData.idKizGlobal,
                                            kizParsed.rawBarcodeCorrectedBase64
                                        );
                                    }

                                    // Экземплярный учет ГИС МТ #94150
                                    try {
                                        let result;
                                        if (props.isPieceAccountingKizOsu || props.gisMtOnlyMode) {
                                            result = setKizOsu(parsedBarcode);
                                        } else if (kizStatus) {
                                            result = setDataKizVerify(parsedBarcode, kizStatus, scanDataBase64);
                                        } else {
                                            innerReject(new Error("kizStatus is null"));
                                            return;
                                        }
                                        innerResolve(result);
                                    } catch (error) {
                                        innerReject(error);
                                    }
                                });
                            });
                        };

                        const addKizBox = async (kizStatus: IKizStatusDTO | null = null): Promise<any> => {
                            return new Promise(() => {
                                kizDataProvider.parse(encodedBarcode, (parsedBarcode) => {
                                    const idGlobal = props.documentType === DocumentType.disaggregation
                                        && kizStatus?.kizBoxData?.idKizBoxGlobal
                                        ? kizStatus.kizBoxData.idKizBoxGlobal
                                        : uuidv4();

                                    const boxData = {
                                        ...parsedBarcode.kizBoxData, 
                                        idGlobal: idGlobal, 
                                        quantity: (props.scalingRatio?.numerator ?? props.totalScanCount) ?? props.numerator
                                    };

                                    props.setBoxData([...props.boxData, boxData], {
                                        ...parsedBarcode.kizBoxData,
                                        idGlobal: idGlobal,
                                        quantity: (props.scalingRatio?.numerator ?? props.totalScanCount) ?? props.numerator,
                                    });

                                    if (props.documentType === DocumentType.disaggregation && !props.isPalette) {
                                        kizDataProvider.getKizBySscc(parsedBarcode.kizBoxData.sscc, (data) => {
                                            props.setKizData(data);
                                            props.setCanScanKizBox(false);
                                        });
                                    }
                                });
                            });
                        };

                        const validateKizState = async (): Promise<any> => {
                            return new Promise((innerResolve, innerReject) => {
                                kizDataProvider.getKizStatus(
                                    encodedBarcode,
                                    async (kizStatus: IKizStatusDTO) => {
                                        try {
                                            if (kizStatus.kizType === BarcodeType.Kiz) {
                                                if (props.canScanKiz) {
                                                    const result = await addKiz(kizStatus);
                                                    innerResolve(result);
                                                    return;
                                                }
                                            } else if (kizStatus.kizType === BarcodeType.KizBox) {
                                                if (props.canScanKizBox) {
                                                    await addKizBox(kizStatus);
                                                    return;
                                                }
                                            } else if (kizStatus.kizType === BarcodeType.kizOsu) {
                                                if (props.kizOsu?.barcode) {
                                                    renderGlobalAlert({
                                                        variant: "danger",
                                                        statusCode: 500,
                                                        title: "Данные уже внесены. В данную форму необходимо вносить только один код",
                                                        detail: `BARCODE: ${kizParsed.rawBarcodeCorrected}\r\nBASE64_ENCODED: ${scanDataBase64}`,
                                                        instance: "Ошибка",
                                                        isSound: true
                                                    });
                                                    setIsSelectScan(true);
                                                    return;
                                                }

                                                // Add single KizOsu
                                                const kizOsuResult = await new Promise((kizResolve) => {
                                                    kizDataProvider.parse(encodedBarcode, (parseBarcode) => {
                                                        const result = setKizOsu(parseBarcode);
                                                        kizResolve(result);
                                                    });
                                                });
                                                
                                                innerResolve(kizOsuResult);
                                                return;
                                            }
                                            
                                            innerResolve({ status: 'no_action_taken' });
                                        } catch (error) {
                                            innerReject(error);
                                        }
                                    },
                                    async () => {
                                        try {
                                            const parseResult = await new Promise((parseResolve, parseReject) => {
                                               if(isBoxGisMtTab) {
                                                    kizDataProvider.parseBoxGisMt(encodedBarcode, typeForBoxGisMt,(parsedBarcode) => {
                                                        const idGlobal = uuidv4();

                                                        props.setBoxGismtData([
                                                            ...props.boxGismtData, {
                                                            ...parsedBarcode.kizBoxGisMtData,
                                                            idGlobal: idGlobal,
                                                            quantity: props.scalingRatio?.numerator ?? props.numerator
                                                        }], {
                                                            ...parsedBarcode.kizBoxGisMtData,
                                                            idGlobal: idGlobal,
                                                            quantity: props.scalingRatio?.numerator ?? props.numerator,
                                                        });
                                                        props.setBarcode("");
                                                        clearData();
                                                    });
                                                } else {
                                                    kizDataProvider.parse(encodedBarcode, (parsedBarcode) => {
                                                        try {
                                                            if (definitionKizScan(parsedBarcode.barcodeType, ScanKizTabTitle)) {
                                                                const newKiz = getKizDto(parsedBarcode);
                                                                const result = setKizData(newKiz, parsedBarcode);
                                                                if (result != null) {
                                                                    parseResolve(result);
                                                                }
                                                            }
                                                            else if (definitionKizScan(parsedBarcode.barcodeType, ScanKizOsuTabTitle)) {
                                                                const result = setKizOsu(parsedBarcode);
                                                                parseResolve(result);
                                                            } else if (parsedBarcode.barcodeType === BarcodeType.KizBox && props.canScanKizBox) {
                                                                const idGlobal = uuidv4();
                                                                const boxData = { 
                                                                    ...parsedBarcode.kizBoxData, 
                                                                    idGlobal: idGlobal, 
                                                                    quantity: props.scalingRatio?.numerator ?? props.numerator 
                                                                };
                                                                
                                                                props.setBoxData([...props.boxData, boxData], {
                                                                    ...parsedBarcode.kizBoxData,
                                                                    idGlobal: idGlobal,
                                                                    quantity: props.scalingRatio?.numerator ?? props.numerator,
                                                                });
                                                                parseResolve({ 
                                                                    type: 'kizBox', 
                                                                    idGlobal, 
                                                                    data: parsedBarcode.kizBoxData 
                                                                });
                                                            } else {
                                                                parseResolve({ status: 'unrecognized_barcode_type' });
                                                            }
                                                        } catch (error) {
                                                            parseReject(error);
                                                        }
                                                    });
                                                }
                                            });
                                            
                                            innerResolve(parseResult);
                                        } catch (error) {
                                            innerReject(error);
                                        }
                                    }
                                );
                            });
                        };

                        const searchKizAndShowError = async (): Promise<any> => {
                            try {
                                const kiz = await new Promise<IKizDTO | null>((searchResolve, searchReject) => {
                                    kizDataProvider.searchByGtinSgtin(
                                        kizParsed.gtinSgtin,
                                        searchResolve,
                                        () => {
                                            searchResolve(null);
                                        }
                                    );
                                });

                                if (kiz) {
                                    showKizConfirmedError();
                                    setIsSelectScan(true);
                                    return { status: 'exists', kiz };
                                }

                                return await addKiz(null);
                            } catch (error) {
                                console.error("Ошибка поиска КИЗ:", error);
                                throw error;
                            }
                        };

                        const handleGisMtMode = async (): Promise<any> => {
                            try {
                                const kiz = await new Promise<IKizDTO | null>((searchResolve, searchReject) => {
                                    kizDataProvider.searchByGtinSgtin(
                                        kizParsed.gtinSgtin,
                                        searchResolve,
                                        searchReject
                                    );
                                });

                                if (kiz) {
                                    showKizConfirmedError();
                                    setIsSelectScan(true);
                                    return { status: 'exists', kiz };
                                }

                                return await addKiz(null);
                            } catch (error) {
                                console.error("Ошибка в режиме ГИС МТ:", error);
                                throw error;
                            }
                        };

                        const handleNotAllowedResponse = async (): Promise<any> => {
                            if (props.gisMtOnlyMode) {
                                return await searchKizAndShowError();
                            } else {
                                showDefaultError();
                                return { 
                                    status: 'not_allowed',
                                    errorMessages: response.errorMessages 
                                };
                            }
                        };

                        const showDefaultError = () => {
                            setCannotBeCreated({
                                isAllow: true,
                                errorMessages: response.errorMessages
                            });

                            console.error(
                                `Невозможно использовать отсканированный ШК. ${response.errorMessages}`,
                                scanDataBase64
                            );

                            renderGlobalAlert({
                                variant: "error",
                                statusCode: 500,
                                title: "Невозможно использовать отсканированный ШК",
                                detail: `BARCODE: ${kizParsed.rawBarcodeCorrected}\r\nBASE64_ENCODED: ${scanDataBase64}. ${response.errorMessages}`,
                                instance: "Ошибка",
                                isSound: true
                            });
                        };

                        const showKizConfirmedError = () => {
                            renderGlobalAlert({
                                variant: "error",
                                statusCode: 500,
                                title: "Невозможно использовать отсканированный ШК - КИЗ подтверждён",
                                detail: `BARCODE: ${kizParsed.rawBarcodeCorrected}\r\nBASE64_ENCODED: ${scanDataBase64}`,
                                instance: "Ошибка",
                                isSound: true
                            });
                        };

                        // Основная логика обработки
                        try {
                            if (!response.isAllow) {
                                const result = await handleNotAllowedResponse();
                                resolve(result);
                                return;
                            }

                            if (props.gisMtOnlyMode) {
                                const result = await handleGisMtMode();
                                resolve(result);
                                return;
                            }

                            if (props.onCustomAllow) {
                                props.onCustomAllow(props.document?.idDocument, scanDataBase64)
                                    .then(async (customResult) => {
                                        if (customResult) {
                                            const validationResult = await validateKizState();
                                            resolve(validationResult);
                                        }
                                    })
                                    .catch((error) => {
                                        reject(error);
                                    });
                            } else {
                                const result = await validateKizState();
                                resolve(result);
                            }
                            
                        } catch (error) {
                            reject(error);
                        }
                    }
                );
            });
        } else {
            return Promise.reject(new Error("Invalid barcode"));
        }
    };

    const setKizOsu = (parsedBarcode: IParsedBarcode): ProcessKizReturnType => {
        if (props.isPieceAccountingKizOsu || props.gisMtOnlyMode) {
            const newKiz = {
                ...parsedBarcode.kizData ?? parsedBarcode.kizOsuData,
                idGlobal: uuidv4(),
            };

            return {
                type: 'isPieceAccountingKizOsu',
                kiz: newKiz,
            }
        } else {
            const { barcode, gtin, gtinSGtin, sGtin } = parsedBarcode.kizData ?? parsedBarcode.kizOsuData;
            const kizOsuData: IKizOsuEditDTO = {
                barcode,
                gtin,
                gtinSGtin,
                idDocumentItem: props.idDocumentItem,
                sGtin,
            };

            return {
                type: 'kizOsu',
                kiz:  kizOsuData
            }
        }
    }

    useEffect(() => {
        if (!cannotBeCreated) {
            isValid(barcode.barcode);
        }
    }, [cannotBeCreated]);

    const clearData = () => {
        setError('');
    };

    const deleteItem = (): void => {

        props.setKizOsuData?.(undefined);

        const handleKizOsuDtosDelete = () => {
            const selectedId = props.selectedKizOsuDtosItem?.idGlobal;
            if (!selectedId) return;
            removeKizOsuDtosById(selectedId)
            props.setSelectedKizOsuDtosItem(undefined)
        }

        const handleBoxGismtDelete = () => {
            const selectedId = props.selectedBoxGismtItem?.idGlobal;
            if (!selectedId) return;
            removeBoxGismtById(selectedId)
            props.setSelectedBoxGismtItem(undefined)
        }

        const handleKizDelete = () => {
            const selectedId = props.selectedKizItem?.idGlobal;
            if (!selectedId) return;

            if (props.confirmationMode) {
                const recordKiz = props.kizData.find(x => x.idGlobal === selectedId);
                if (!recordKiz) return;

                const matchExists = props.kizConfirmationScanned.some(
                    x => x.infoScanned === recordKiz.gtinSGtin
                );

                if (matchExists) {
                    const updatedConfirmation = props.kizConfirmationScanned.map(item =>
                        item.infoScanned === recordKiz.gtinSGtin
                            ? { ...item, infoScanned: "" }
                            : item
                    ) as IKizConfirmationData[];

                    props.setKizConfirmationScanned(updatedConfirmation);
                    props.setSelectedKizItem(undefined);
                }

                return;
            }

            if (isEditKizs) {
                removeKizDataById(selectedId);
                props.setSelectedKizItem(undefined);
                return;
            }

            const kizDelete = props.kizData.find(c => c.idGlobal === selectedId);
            if (!kizDelete) return;

            if (props.documentType === DocumentType.disaggregation) {
                if (kizDelete.isHandScan) {
                    removeKizDataById(selectedId);
                } else {
                    props.setKizData([
                        ...props.kizData.filter(x => x.idGlobal !== selectedId),
                        { ...kizDelete, isTrusted: undefined }
                    ]);
                }
            } else {
                removeKizDataById(selectedId);
            }

            props.setSelectedKizItem(undefined);
        };

        const removeKizDataById = (id: string) => {
            props.setKizData(props.kizData.filter(x => x.idGlobal !== id));
        };

        const removeKizOsuDtosById = (id:string) => {
            props.setKizOsuDtos(props.kizOsuDtos.filter(x => x.idGlobal !== id));
        }

        const removeBoxGismtById = (id:string) => {
            props.setBoxGismtData(props.boxGismtData.filter(x => x.idGlobal !== id));
        }

        // Для коробов
        const handleBoxDelete = () => {
            if (props.documentType === DocumentType.disaggregation) {
                props.setCanScanKizBox(true);
                props.setKizData([]);

                if (props.confirmationMode) {
                    const selectedId = props.selectedBoxItem?.idGlobal;
                    if (!selectedId) return;

                    const recordBox = props.boxData.find(x => x.idGlobal === selectedId);
                    if (!recordBox) return;

                    const matchExists = props.kizConfirmationScanned.some(
                        x => x.infoScanned === recordBox.sscc
                    );

                    if (matchExists) {
                        const updatedConfirmation = props.kizConfirmationScanned.map(item =>
                            item.infoScanned === recordBox.sscc
                                ? { ...item, infoScanned: "" }
                                : item
                        ) as IKizConfirmationData[];

                        props.setKizConfirmationScanned(updatedConfirmation);
                        props.setSelectedBoxItem(undefined);
                    }

                    return;
                }

                props.setBoxData([]);
                props.setSelectedBoxItem(undefined);
                return;
            }

            if (!isEditKizs || props.confirmationMode) {
                props.setBoxData(props.boxData.filter(x => x.idGlobal !== props.selectedBoxItem?.idGlobal));
                props.setSelectedBoxItem(undefined);
            }
        };

        // Общая логика
        if (props.isKiz) {
            handleKizDelete();
        } 
        else if (props.kizOsuDtos?.length > 0 && (props.isPieceAccountingKizOsu || props.gisMtOnlyMode))
        {
            handleKizOsuDtosDelete();
        }
        else if (props.boxGismtData?.length > 0) {
            handleBoxGismtDelete();
        }
        else {
            handleBoxDelete();
        }
    };

    useEffect(() => {
        if (props.executeAfterScan?.[0] === true) {
            addData();
            props.executeAfterScan[1](false);
        }

    }, [props.executeAfterScan[0]])

    // Инициализация списка КИЗ в режиме недоверия поставщику
    useEffect(() => {
        if (props.confirmationMode === true && props.kizData.length > 0 && props.kizConfirmationScanned.length === 0 && !props.isPalette) {
            const supplierKizList = props.kizData.map(x => {
                return {
                    idGlobal: x.idGlobal,
                    infoSupplier: x.gtinSGtin,
                    infoScanned: x.isTrusted ? x.gtinSGtin : ""
                } as IKizConfirmationData
            });
            props.setKizConfirmationScanned(supplierKizList);
        }
    }, [props.kizData])

    // Так же для коробов в режиме палеты
    useEffect(() => {
        if (props.confirmationMode === true && props.boxData.length > 0 && props.kizConfirmationScanned.length === 0 && props.isPalette) {
            const supplierBoxList = props.boxData.map(x => {
                return {
                    idGlobal: x.idGlobal,
                    infoSupplier: x.sscc,
                    infoScanned: x.isTrusted ? x.sscc : ""
                } as IKizConfirmationData
            });
            props.setKizConfirmationScanned(supplierBoxList);
        }
    }, [props.boxData])

    const clearItems = (): void => {

        // Общие сбросы
        props.setKizOsuData?.(undefined);
        props.setKizOsuDtos?.([]);
        props.setSelectedKizItem(undefined);
        props.setSelectedBoxItem(undefined);
        props.setSelectedKizOsuDtosItem(undefined);
        props.setSelectedBoxGismtItem(undefined);
        props.setBoxGismtData?.([]);

        // Если работа только с КИЗ
        if (props.isKiz) {
            if (props.confirmationMode) {
                props.setKizConfirmationScanned([]);
            } else {
                props.setKizData([]);
            }
            return;
        }

        // Для акта разагрегации контролируем сброс данных по коробам
        if (props.documentType === DocumentType.disaggregation) {
            props.setKizData([]);
            props.setCanScanKizBox(true);

            if (props.confirmationMode) {
                props.setKizConfirmationScanned([]);
            } else {
                props.setBoxData([]);
            }
            return;
        }

        props.setBoxData([]);
    };

    const getCountDisagregation = (): JSX.Element => {
        if (props.detailsTabsPanel.currentTab?.title === ScanBoxTabTitle && !props.isPalette) {
            return <span className={Styles.ScanCount}>{`ОТСКАНИРОВАНО (${props.boxData.length > 0 ? 1 : 0} ИЗ ${1})`}</span>
        }
        else if (props.detailsTabsPanel.currentTab?.title === PaletteBoxTabTitle && props.isPalette) {
            return <span className={Styles.ScanCount}>{`ОТСКАНИРОВАНО (${props.paletteData.length > 0 ? 1 : 0} ИЗ ${1})`}</span>
        }
        else if (props.detailsTabsPanel.currentTab?.title === ScanBoxTabTitle && props.isPalette) 
        {
            let countConfirm = props.confirmationMode ? props.kizConfirmationScanned.filter(x => x.infoScanned && x.infoScanned.length > 0).length : props.boxData.length
            return <span className={Styles.ScanCount}>{`ОТСКАНИРОВАНО (${countConfirm} ИЗ ${props.totalScanBoxCount})`}</span>
        }
        else {
            let countConfirm = props.kizConfirmationScanned.filter(x => x.infoScanned && x.infoScanned.length > 0).length
            return <span className={Styles.ScanCount}>{`ОТСКАНИРОВАНО (${countConfirm} ИЗ ${props.scanCounts.box * props.numerator})`}</span>
        }
    }

    const setCounter = (): JSX.Element => {
        if (props.documentType !== DocumentType.disaggregation) {
            let total = props.totalScanCount

            let isDivided = ((props.scalingRatio?.numerator ?? 1) < (props.scalingRatio?.denominator ?? 1)) && (props.documentType !== DocumentType.importRemains);
            if (isDivided) {
                total = props.totalScanCount ?? 1;
            }

            let isBoxStandart = props.isKizBox && props.numerator > 1;

            let scanText: string = `ОТСКАНИРОВАНО (${isBoxStandart ? props.boxData.length : props.scanCount} ИЗ ${total})`;
            return <span className={Styles.ScanCount}>{scanText}</span>;
        }
        return getCountDisagregation();
    };

    const isChangeScalingRatio = (): number | undefined => {
        if (props.documentType !== DocumentType.invoice) return undefined
        if (props.boxData.length > 1) return undefined
        if (!props.scalingRatio) return undefined
        if (props.totalScanCount > 1) return undefined
        if (!props.isKizBox && props.scalingRatio.numerator === 1) return undefined
        if (props.scalingRatio.denominator > 1) return undefined
        return props.scalingRatio?.numerator
    }

    const getOrCreateScalingRatio = (quantity: number) => {
        if (!props.idGoodsGlobal) return
        if (!isChangeScalingRatio()) return
        if (quantity === props.scalingRatio?.numerator) return


        scalingRatioProvider.getByScalingRatioListById(props.idGoodsGlobal, (e) => {
            let result = e.find(c => c.numerator === quantity)
            if (result) {
                props.setScalingRatio(result)
            }

            scalingRatioProvider.overrideCreate(props.idGoodsGlobal as string,
                {
                    denominator: 1,
                    idGlobal: uuidv4(),
                    numerator: quantity,
                    unit: props.scalingRatio?.unit
                } as IScalingRatioDTO, (e) => {
                    scalingRatioProvider.getById(e, (e) => {
                        props.setScalingRatio(e)
                    })
                })
        })
    }

    const getKizPluginSettings = () => {
        if (props.documentType === DocumentType.disaggregation) return ScanKizActDisagregationPluginSettings
        return ScanKizCreatePluginSettings
    }

    const confrimScannedBarcode = (scannedBarcode: string): void => {
        const barcode = cyrillicKeyboardTranslation(scannedBarcode);
        const isBox = KizBoxEntity.isKizBox(barcode);

        const getScannedInfo = (barcode: string): string | null => {
            try {
                if (isBox) {
                    return barcode;
                } else if (KizEntity.isKiz(barcode, props.stringEncoding)) {
                    const parsedKiz = KizEntity.parse(barcode, props.stringEncoding);
                    return `${parsedKiz.gtin}${parsedKiz.sGtin}`;
                }
            } catch (error) {
                console.warn('Ошибка парсинга КИЗ', error);
            }

            return null;
        };

        let infoScanned = getScannedInfo(barcode);

        if (!infoScanned) {
            setError(errorsT("wrongFormatKizOrKizBox"))
            return;
        }

        if (isBox) infoScanned = infoScanned.replace(/^00+/, '');

        const matchedItem = props.kizConfirmationScanned.find(item => item.infoSupplier === infoScanned)
        if (!matchedItem) {
            setError(errorsT("scannedKizDismatched"))
            return;
        }

        const updateScannedList = (list: IKizConfirmationData[], infoScanned: string): IKizConfirmationData[] => {
            return list.map(item =>
                item.infoSupplier === infoScanned && !item.infoScanned
                    ? { ...item, infoScanned }
                    : item
            );
        };

        const confirmationNewState = updateScannedList(props.kizConfirmationScanned, infoScanned);
        props.setKizConfirmationScanned(confirmationNewState);

        // Сброс поля ввода
        props.setBarcode("");
    };

    const addData = async ()  => {
        const barcodes = props.barcode.split(/(?=^\d{2}|\n\d{2}| \d{2})/gm).map(item => item.trim())
        .filter(item => {
            return (
            item.startsWith('01') || 
            /^\d{18,20}$/.test(item)
            );
        });

        // Отдельная логика для режима подтверждения КИЗ
        if (props.confirmationMode && barcodes.length === 1) {
            confrimScannedBarcode(barcodes[0]);
            return;
        }

        if (barcodes.length == 0) barcodes.push(props.barcode)

        const kizResults: IKizDTO[] = [];
        const kizOsuResults: IKizOsuEditDTO[] = [];
        const kizOsuDtosResults: IKizDTO[] = [];
        const duplicateBarcodes: string[] = []; // Массив для хранения дубликатов
        const processedBarcodesSet = new Set<string>(); // Set для отслеживания обработанных штрихкодов
        // Обработка нескольких штрихкодов (последовательно)
        if (barcodes.length >= 2) {
            
            const scanCountMax = (props.totalScanCount -  props.scanCount)
            if (scanCountMax < barcodes.length) {
                renderGlobalAlert({
                    variant: "error",
                    statusCode: 500,
                    title: "Превышено количество вставленных кизов",
                    detail: `Можно отсканировать кизов ${scanCountMax} шт, было отсканировано ${barcodes.length} шт.`,
                    instance: "Превышение",
                    isSound: true
                });
                return
            }

            setProcessingStats({
                isProcessing: true,
                current: 0,
                total: barcodes.length,
                errors: 0
            });

            // Функция для последовательной обработки штрихкодов
            const processBarcodesSequentially = async () => {
                try {
                    for (let i = 0; i < barcodes.length; i++) {
                        const barcode = barcodes[i];

                        // Проверяем на дубликат
                        if (processedBarcodesSet.has(barcode)) {
                            duplicateBarcodes.push(barcode);
                            
                            // Пропускаем обработку дубликата
                            setProcessingStats(prev => ({
                                ...prev,
                                current: i + 1
                            }));
                            continue;
                        }
                        
                        // Добавляем штрихкод в обработанные
                        processedBarcodesSet.add(barcode);
                        
                        // Обрабатываем штрихкод
                        let processedBarcode = barcode + '=';
                        processedBarcode = processedBarcode.replace(/\s/g, "");
                        processedBarcode = processedBarcode.length === 18 
                            ? '00' + processedBarcode 
                            : cyrillicKeyboardTranslation(processedBarcode);
                        
                        const tabCurrent = props.detailsTabsPanel.currentTab;
                        if (tabCurrent) {
                           
                            const result = await processKiz(barcode)

                            if (result.type == 'isPieceAccountingKizOsu') {
                                  kizOsuDtosResults.push(result.kiz);
                            }

                            if (result.type == 'kiz') {
                                kizResults.push(result.kiz)
                            }

                            if (result.type == 'kizOsu') {
                                kizOsuResults.push(result.kiz)
                            }
                        }

                        setProcessingStats(prev => ({
                            ...prev,
                            current: i + 1
                        }));
                    }

                    // Выводим дубликаты, если они есть
                    if (duplicateBarcodes.length > 0) {
                        console.warn('Найдены дубликаты штрихкодов:', duplicateBarcodes);
                        // Можно добавить уведомление для пользователя
                        renderGlobalAlert({
                            variant: "error",
                            statusCode: 500,
                            title: "Найдены дубликаты",
                            detail: `Найдены дубликаты (${duplicateBarcodes.length} шт.): ${duplicateBarcodes.join(', ')}`,
                            instance: "Дубликаты",
                            isSound: true
                        });
                    }
                    
                    if (kizOsuDtosResults.length > 0) {
                        // Получаем текущие данные и добавляем новые
                        const currentKizOsuDtos = props.kizOsuDtos || [];
                        props.setKizOsuDtos([...currentKizOsuDtos, ...kizOsuDtosResults]);
                    }

                    if (kizResults.length > 0) {
                        
                        const currentKizData = props.kizData || [];
                        props.setKizData?.([...currentKizData, ...kizResults]);
                    }

                    if (kizOsuResults.length > 0) {
                        props.setKizOsuData?.(kizOsuResults[0]);
                    }

                    props.setBarcode("");
                    clearData();

                } catch (error) {
                    console.error('Ошибка при обработке штрихкодов:', error);
                } finally {
                    setProcessingStats(prev => ({
                        ...prev,
                        isProcessing: false
                    }));
                }
            };
            
            // Запускаем последовательную обработку
            processBarcodesSequentially();
        }

        // Обработка одного штрихкода
        if (barcodes.length === 1) {
            let _barcode: string = props.barcode.replace(/\s/g, "");
            _barcode = _barcode.length === 18 ? '00' + _barcode : cyrillicKeyboardTranslation(_barcode);

            const tabCurrent = props.detailsTabsPanel.currentTab;
            if (tabCurrent) {
                const result = await processKiz(_barcode)

                if (result.type == 'isPieceAccountingKizOsu') {
                    props.setKizOsuDtos([...props.kizOsuDtos, { ...result.kiz }]);
                }

                if (result.type == 'kizOsu') {
                    props.setKizOsuData?.(result.kiz);
                }

                if (result.type == 'kiz') {
                    props.setKizData([...props.kizData, { ...result.kiz }]);
                }

                props.setBarcode("");
            }
        }
    };

    const changeKizItem = () => {
        if (props.isKiz) {
            if (props.selectedKizItem?.idGlobal) {
                setIsCanDeleteSelected(false);
                isEditKizsCanDelete(props.selectedKizItem?.idGlobal, props.isKiz, (value: boolean, idGlobal: string) => {
                    if (idGlobal === props.selectedKizItem?.idGlobal)
                        setIsCanDeleteSelected(value);
                })
            }
            else
                setIsCanDeleteSelected(false);
        }
    }

    const changeKizBoxItem = () => {
        if (!props.isKiz) {
            if (props.selectedBoxItem?.idGlobal) {
                setIsCanDeleteSelected(false);
                isEditKizsCanDelete(props.selectedBoxItem?.idGlobal, props.isKiz, (value: boolean, idGlobal: string) => {
                    if (idGlobal === props.selectedBoxItem?.idGlobal)
                        setIsCanDeleteSelected(value);
                })
            }
            else
                setIsCanDeleteSelected(false);
        }
    }
    const changeKizBoxGismtItem = () => {
        if (props.selectedBoxGismtItem?.idGlobal) {
            setIsCanDeleteSelected(false);
            isEditKizsCanDelete(props.selectedBoxGismtItem?.idGlobal, props.isKiz, (value: boolean, idGlobal: string) => {
                if (idGlobal === props.selectedBoxGismtItem?.idGlobal)
                    setIsCanDeleteSelected(value);
            })
        }
        else
            setIsCanDeleteSelected(false);
    }

    useEffect(() => {
        if (isEditKizs)
            changeKizItem();
    }, [props.selectedKizItem])

    useEffect(() => {
        if (isEditKizs)
            changeKizBoxItem();
    }, [props.selectedBoxItem])

    useEffect(() => {
        if (isEditKizs)
            changeKizBoxGismtItem();
    }, [props.selectedBoxGismtItem])


    useEffect(() => { //срабатывает при изменении вкладки киз/короб
        if (isEditKizs) {
            changeKizItem();
            changeKizBoxItem();
            changeKizBoxGismtItem();

            let barcodes: string[] = [];
            if (props.isKiz) {
                props.kizData.forEach(x => {
                    barcodes.push(x.barcode);
                });
            }
            else {
                props.boxData.forEach(x => {
                    barcodes.push(x.barcode);
                });
            }
            const dto = {
                barcodes: barcodes,
                idDocument: props.document.idDocument,
            } as IKizStatusMoveErrorInDTO
            kizDataProvider.getKizStatusMoveErrors(dto, (e) => {
                let can = true;
                for (let i = 0; i < e.length; i++) {
                    const data = e[i].kizType === BarcodeType.Kiz ? e[i].kizData : e[i].kizBoxData;
                    const flag = getCanDelete(data);
                    if (flag === false) {
                        can = false;
                        break;
                    }
                }
                setIsCanDeleteAll(can);
            }, () => { });
        }
    }, [props.isKiz])

    const getCanDelete = (data: any): boolean => {
        let canDeleted: boolean;
        if (data.idError > 0) //ошибки от мдлп
            canDeleted = true;
        else if (data.idError === 0 || data.idError === -3) //успешный статус или очередь
            canDeleted = false;
        else if (data?.kizState === KizStateType.save || data?.kizState === KizStateType.hold) //статус киза hold или save и статус в kizmove не ОК	
            return true;
        else if ((data.idError === -2 || data.idError === -1) && data.state === 'NEW' && data.idState === 0) //idError = -1 это правка для нового киз-сервера
            canDeleted = true;
        else if (data.idError === -2 || data.idError === -1)
            canDeleted = false;
        else
            canDeleted = true; //ошибки киз-сервера -1, -4, -5, -6, -7, -8
        return canDeleted;
    }

    const isEditKizsCanDelete = (idGlobal: string, isKiz: boolean, callback: (value: boolean, idGlobal: string) => void) => {
        let barcode: string | undefined;
        let kiz: IKizDTO | undefined = props.kizData.find((x) => x.idGlobal === idGlobal);
        let kizBox: IKizBoxDTO | undefined = props.boxData.find((x) => x.idGlobal === idGlobal);
        let kizBoxGismt: IKizBoxGismtDTO | undefined = props.boxGismtData.find((x) => x.idGlobal === idGlobal);
        let isKizType: boolean = false;
        
        if (kiz) {
            barcode = kiz?.barcode;
            isKizType = true;
        } else if (kizBox) {
            barcode = kizBox?.barcode;
            isKizType = false;
        } else if (kizBoxGismt) {
            barcode = kizBoxGismt?.barcode;
            isKizType = false; // Короба ГИС МТ тоже не являются КИЗами
        }
        if (!barcode) {
            callback(false, idGlobal);
            return;
        }
        kizDataProvider.getKizStatusMoveError(
            barcode,
            props.document.idDocument,
            (e) => {
                let canDeleted: boolean;
                let data: any;
                
                if (e.kizType === BarcodeType.Kiz) {
                    data = e.kizData;
                } else if (e.kizType === BarcodeType.KizBox) {
                    data = e.kizBoxData;
                } else if (e.kizType === BarcodeType.KizBoxGisMt) {
                    data = e.kizBoxGisMtData;
                } else {
                    data = e.kizData || e.kizBoxData || e.kizBoxGisMtData;
                }

                canDeleted = getCanDelete(data);
                callback(canDeleted, idGlobal);
            },
            () => {
                callback(false, idGlobal);
            }
        );
    }

    const getComponentGrid = (item: ITab): JSX.Element => {
        if (!showGrid) return <></>
        if (item.title === ScanKizTabTitle) {
            
            return !props.confirmationMode ?
                (
                    <KizModalContent
                        kizData={props.kizData}
                        setKizData={(data) => props.setKizData(data)}
                        boxData={props.boxData}
                        pluginSettings={getKizPluginSettings()}
                        setBoxData={(data) => props.setBoxData(data)}
                        selectedItem={props.selectedKizItem}
                        setSelectedItem={(data) => props.setSelectedKizItem(data)}
                        totalScanCount={props.totalScanCount}
                        scanCount={props.scanCount}
                        isEditKizs={isEditKizs}
                        styleCell={props.documentType === DocumentType.disaggregation}
                    />
                ) :
                (
                    <ScanKizConfirmationModalContent
                        kizConfirmationData={props.kizConfirmationScanned}
                        selectedItem={props.selectedKizItem}
                        setSelectedItem={(data) => props.setSelectedKizItem(data)}
                        totalScanCount={props.totalScanCount}
                        scanCount={props.scanCount}
                        isEditKizs={isEditKizs}
                        plugin={ScanKizConfirmationViewPluginSettings}
                    />
                )
        }

        if (item.title === ScanBoxGismtTabTitle) {
            return !props.confirmationMode ?
            (
                <BoxGismtModalContent
                    boxGismtData={props.boxGismtData} 
                    selectedItem={props.selectedBoxGismtItem}
                    setSelectedItem={(data) => props.setSelectedBoxGismtItem(data)}
                    numerator={isChangeScalingRatio()}
                    documentType={props.documentType}
                    onBlur={(e) => {
                        getOrCreateScalingRatio(e)
                    }}
                    setBoxGismtData={(value: IKizBoxGismtDTO) => {
                        props.setBoxGismtData(props.boxGismtData.map((x) => (x.idGlobal === value.idGlobal ? { ...x, ...value } : x)));
                    }}
                    isEditKizs={isEditKizs}
                    setAllBoxData={handleSetAllBoxGismtData}
                />
            ) :
            (
                <ScanKizConfirmationModalContent
                    kizConfirmationData={props.kizConfirmationScanned}
                    selectedItem={props.selectedBoxGismtItem}
                    setSelectedItem={(data) => props.setSelectedBoxGismtItem(data)}
                    totalScanCount={props.totalScanCount}
                    scanCount={props.scanCount}
                    plugin={ScanKizConfirmationViewPluginSettings}
                />
            )
        }

        if (item.title === ScanBoxTabTitle) {
            return (!(props.confirmationMode && props.isPalette) ?
                (
                    <BoxModalContent
                        boxData={props.boxData}
                        selectedItem={props.selectedBoxItem}
                        setSelectedItem={(data) => props.setSelectedBoxItem(data)}
                        numerator={isChangeScalingRatio()}
                        documentType={props.documentType}
                        onBlur={(e) => {
                            getOrCreateScalingRatio(e)
                        }}
                        setBoxData={(value: IKizBoxDTO) => {
                            props.setBoxData(props.boxData.map((x) => (x.idGlobal === value.idGlobal ? { ...x, ...value } : x)));
                        }}
                        isEditKizs={isEditKizs}
                        setAllBoxData={handleSetAllBoxData}
                    />
                ) :
                (
                    <ScanKizConfirmationModalContent
                        kizConfirmationData={props.kizConfirmationScanned}
                        selectedItem={props.selectedBoxItem}
                        setSelectedItem={(data) => props.setSelectedBoxItem(data)}
                        totalScanCount={props.totalScanCount}
                        scanCount={props.scanCount}
                        plugin={ScanKizConfirmationViewPluginSettings}
                    />
                ))
        }

        if (item.title === PaletteBoxTabTitle && props.documentType === DocumentType.disaggregation) {
            return (<PaletteModalContent
                boxData={props.paletteData}
                selectedItem={undefined}
                setSelectedItem={() => { }}
                documentType={props.documentType}
                setBoxData={() => { }}
                isEditKizs={false} />)
        }

        if (item.title === ScanKizOsuTabTitle) {
            return (
                <KisOsuModalContent
                    kizsOsuDto={props?.kizOsu ? [props.kizOsu] : []}
                    kizsDto={props.kizOsuDtos}
                    isPieceAccountingKizOsu={props.gisMtOnlyMode === true ? true : props.isPieceAccountingKizOsu}
                    selectedItem={props.selectedKizOsuDtosItem}
                    setSelectedItem={(data) => {
                        props.setSelectedKizOsuDtosItem(data)
                    }}
                    setKizOsuData={() => {}}
                />
            );
        }

        return <></>
    }

    const getTabs = () => {
        const { tabs } = props.detailsTabsPanel;
        const { documentType, isPalette, kizOsu, kizData, boxData, isKizBox, numerator } = props;

        // Если есть ОСУ ШК - показываем все табы
        if (kizOsu?.barcode) {
            return tabs;
        }

        // В режиме подтверждения ГИС МТ - только вкладка ГИС МТ
        if (props.gisMtOnlyMode) {
            return tabs.filter(c => c.title === ScanKizOsuTabTitle);
        }

        // Для disaggregation + палета - скрываем ОСУ и КИЗ и короб ГИС МТ
        if (documentType === DocumentType.disaggregation && isPalette) {
            return tabs.filter(c => c.title !== ScanKizOsuTabTitle && c.title !== ScanKizTabTitle && c.title !== ScanBoxGismtTabTitle);
        }

        // Для disaggregation - скрываем ОСУ и паллеты и короб ГИС МТ
        if (documentType === DocumentType.disaggregation) {
            return tabs.filter(c => c.title !== ScanKizOsuTabTitle && c.title !== PaletteBoxTabTitle && c.title !== ScanBoxGismtTabTitle);
        }

        // Для disassembling без экземплярного учета - скрываем ОСУ и Палеты и короб ГИС МТ
        if (documentType === DocumentType.disassembling && !props.isPieceAccountingKizOsu) {
            return tabs.filter(c => c.title !== ScanKizOsuTabTitle && c.title !== PaletteBoxTabTitle && c.title !== ScanBoxGismtTabTitle);
        }

        // Для disassembling - Палеты и короб ГИС МТ
        if (documentType === DocumentType.disassembling) {
            return tabs.filter(c => c.title !== PaletteBoxTabTitle && c.title !== ScanBoxGismtTabTitle);
        }

        // Для ПН с отсканированными данными - специальная фильтрация
        if ((kizData?.length > 0 || boxData?.length > 0) && documentType === DocumentType.invoice) {
            return tabs.filter(item =>
                !(item.title === PaletteBoxTabTitle) &&
                !(item.title === ScanKizTabTitle && isKizBox && numerator > 1)
            );
        }

        // Для определенных типов документов - скрываем Палеты
        if ([DocumentType.invoice, DocumentType.importRemains, DocumentType.inventoryVed].includes(documentType)) {
            return tabs.filter(c => c.title !== PaletteBoxTabTitle);
        }

        // По умолчанию - скрываем ОСУ и Палеты
        return tabs.filter(c => c.title !== PaletteBoxTabTitle);
    };

    const isDisabledOsu = () => {
        if (props.documentType === DocumentType.invoice ||
            props.documentType === DocumentType.importRemains ||
            props.documentType === DocumentType.inventoryVed) return false

        if (props.kizOsu?.barcode) return true;
        return false;
    }

    const [isCapsLock, setIsCapsLock] = useState(false);

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {        
        checkCapsLock(e,(isCapsLock) => {
            if (isCapsLock) {
                setError(errorsT('capsLockOn'));
                setIsCapsLock(true)
                return
            }
            else {
                setIsCapsLock(false)
                setError('');
            }
        })
        
        // Обработка Enter для отправки формы
        if (e.key === 'Enter') {
            setCannotBeCreated({isAllow: true, errorMessages: ''});
            addData();
        }
    };


    useEffect(() => {

        const tabs = props.detailsTabsPanel.tabs
        const currentTab = props.detailsTabsPanel.currentTab
      
        if ((props.kizData.length || props.boxData.length) && (currentTab?.title === 'КИЗ' || currentTab?.title === 'Короб')) {

            const disabledIds = tabs
                .filter(tab => tab.title !== 'КИЗ' && tab.title !== 'Короб')
                .map(tab => tab.id)

            setDisabledTabsIds(disabledIds)
        } else if ((props.kizOsuDtos.length || props.boxGismtData.length)&& (currentTab?.title === 'ГИС МТ' || currentTab?.title === 'Короб ГИС МТ')) {
            const disabledIds = tabs
                .filter(tab => tab.title !== 'ГИС МТ' && tab.title !== 'Короб ГИС МТ')
                .map(tab => tab.id)

            setDisabledTabsIds(disabledIds)
        } else if (props.kizData.length === 0 &&
            props.boxData.length === 0 &&
            props.kizOsuDtos.length === 0 &&
            props.boxGismtData.length === 0) {
            setDisabledTabsIds([])
        }

    }, [props.kizData.length,
    props.boxData.length,
    props.kizOsuDtos.length,
    props.boxGismtData.length,
    props.detailsTabsPanel?.currentTab?.title,
    props.detailsTabsPanel?.tabs])

    return (
        <>
            <div className={Styles.ToolsPanel}>
                <CommandsPanel
                    groups={[
                        [
                            {
                                iconButton: <Delete2Button sizeVariant="mini" colorVariant="danger" onClick={() => deleteItem()} disabled={(isEditKizs ? !isCanDeleteSelected : false) || isDisabledOsu()} />,
                                text: "Удалить",
                            },
                            {
                                iconButton: <ClearButton sizeVariant="normal" colorVariant="danger" onClick={() => clearItems()} disabled={isEditKizs ? !isCanDeleteAll : false || isDisabledOsu()} />,
                                text: "Очистить",
                            },
                        ],
                    ]}
                />

                <div>
                    {processingStats.isProcessing && (
                        <div>
                            <div>
                                <span>Обработка: {processingStats.current} из {processingStats.total}</span>
                            </div>
                        </div>
                    )}
                </div>

                {setCounter()}
            </div>
            {props.showDevProp && (
                <GridWrapper cols={5}>
                    <TextInput
                        className={Styles.TextInput}
                        autoFocus
                        disabled={isDisabledOsu()}
                        labelClassName={Styles.inlineLabel}
                        inputClassName={Styles.inlineInput}
                        value={props.barcode}    
                        select={[isSelectScan, setIsSelectScan]}
                        isExternalValue
                        onChange={(value) => {
                            props.setBarcode(value.trim());
                            setKizAllow(false);
                            setKizBoxAllow(false);
                            setError('');
                        }}
                        error={error}
                        onKeyDown={handleKeyDown}
                    />
                    <Button
                        disabled={props.barcode.length === 0}
                        className={Styles.Button}
                        variant="outprimary"
                        onClick={() => {
                            if (isCapsLock) return
                            setCannotBeCreated({isAllow: true, errorMessages: ''})
                            addData();
                        }}
                    >
                        <span>{t("general.add")}</span>
                    </Button>
                </GridWrapper>
            )}
            <div>
                {props.detailsTabsPanel.tabs.length > 0 && (
                    <>
                        <TabsPanel
                            id="detailsTabsPanel"
                            activeId={props.detailsTabsPanel.currentTab?.id}
                            tabs={getTabs()}
                            onActive={(id) => {
                                props.dispatchDetailsTabsPanel({ type: "activate", payload: id });
                            }}
                            disabledTabIds={disabledTabIds}
                        />
                        <div>
                            {props.detailsTabsPanel.tabs.map((item, i) => {
                                return (
                                    <div
                                        key={item.id}
                                        className={classNames(
                                            item.id === props.detailsTabsPanel.currentTab?.id ? tabsStyles.contentVisible : tabsStyles.contentHidden,
                                            item.title === ScanKizTabTitle && !props.canScanKiz ? tabsStyles.contentDisabled : "",
                                            item.title === ScanBoxGismtTabTitle && (!props.canScanKizBox && props.documentType === DocumentType.disaggregation) ? tabsStyles.contentDisabled : "",
                                            item.title === ScanBoxTabTitle && (!props.canScanKizBox && props.documentType === DocumentType.disaggregation) ? tabsStyles.contentDisabled : "",
                                            item.title === ScanKizOsuTabTitle && isDisabledOsu() ? tabsStyles.contentDisabled : ""
                                        )}
                                    >
                                        <Accordion onOpen={(isShow) => setShowGrid(isShow)} opened={showGrid} caption={showGrid ? 'Свернуть': 'Развенуть'} id={`${uuidv4()}`}>
                                          {getComponentGrid(item)}
                                        </Accordion>
                                       
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
        </>
    );
    };

export default KizScanModal;

interface IBarcode {
    base64: string;
    barcode: string;
}
function useBarcode(barcode: string) {
    const [base64, setBase64] = useState<string>();

    useEffect(() => {
        setBase64(buffer.Buffer.from(barcode, "ascii").toString("base64"));
    }, [barcode]);

    return {
        base64: base64,
        barcode: barcode,
    } as IBarcode;
}
